import { render, staticRenderFns } from "./GiftSales.vue?vue&type=template&id=5542f162&"
import script from "./GiftSales.vue?vue&type=script&lang=js&"
export * from "./GiftSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports